import React from 'react'
import './skills.css'
import { useLanguage } from '../../context/LanguageContext'
import ScrollReveal from '../shared/ScrollReveal'
import CountUp from '../shared/CountUp'

const Skills = () => {
  const { t } = useLanguage()
  return (
    <div className='container skills__container'>
      <div className='skills__fontimg'></div>
      <ScrollReveal>
      <div className="skills__menu">
        <h2 id="Skills">{t.skills.title}</h2>
        <p>{t.skills.desc1}</p>
        <p>{t.skills.desc2}</p>
        {/* After creation of slider, comment this */}
        {/* <div className="skills__menu--carousel">
          <div className='skills__menu--carousel-items1'>
            <img src={img2} alt="" className='skills__menu--img'/>
            <p>Frontend Development</p>
          </div>
          <div className='skills__menu--carousel-items2'>
            <img src={img3} alt="" className='skills__menu--img'/>
            <p>Backend Development</p>
          </div>
          <div className='skills__menu--carousel-items3'>
            <img src={img1} alt="" className='skills__menu--img'/>
            <p>UI Design</p>
          </div>
        </div> */}
        <div className='skills__impact'>
          {t.skills.impact.map((item, i) => (
            <ScrollReveal key={i} delay={i * 80}>
              <div className='skills__impact--card'>
                <span className='skills__impact--value'>
                  <CountUp end={item.end} suffix={item.suffix} />
                </span>
                <span className='skills__impact--label'>{item.label}</span>
              </div>
            </ScrollReveal>
          ))}
        </div>
        <div className='skills__stack'>
          <p className='skills__stack--title'>{t.skills.stackTitle}</p>
          <div className='skills__stack--badges'>
            {['HTML5', 'CSS3', 'JavaScript', 'TypeScript', 'React', 'Node.js', 'PHP', 'WordPress', 'Figma', 'Git'].map(tech => (
              <span key={tech} className='tech-badge'>{tech}</span>
            ))}
          </div>
        </div>
      </div>
      </ScrollReveal>
    </div>
  )
}

export default Skills